/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {AuthenticateModel} from "../../models/oauth/authenticate-model";
import {AuthenticateResponseModel} from "../../models/oauth/authenticate-response-model";

export interface AuthenticateParams {
    body?: AuthenticateModel,
}

export function oauthAuthorisePost(http: HttpClient, rootUrl: string, params: AuthenticateParams, context?: HttpContext): Observable<StrictHttpResponse<AuthenticateResponseModel>> {
    const rb = new RequestBuilder(rootUrl, oauthAuthorisePost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AuthenticateResponseModel>;
        })
    );
}

oauthAuthorisePost.PATH = '/api/v1/oauth2/authenticate';
